import React, { useState, useEffect, useRef } from "react";
import { useImperativeHandle } from "react";

export const Tabs = React.forwardRef((props, ref) => {
  const { tabs, defaultTab, onTabChange } = props;
  useImperativeHandle(ref, () => ({
    navigateNext,
    tabs,
  }));
  let { children } = props;
  if (children.map === undefined) {
    children = [children];
  }
  const tabsRef = useRef();
  // console.log(children);
  const [openedTab, setOpenedTab] = useState(defaultTab || 0);

  const navigateNext = () => {
    setOpenedTab((prev) => (prev + 1 >= tabs.length ? prev : prev + 1));
  };

  const navigatePrev = () => {
    console.log("Navigating back!");
  };

  const navigateTo = (tabIndex) => {
    if (isNaN(tabIndex)) {
      throw `Invalid Argument! 'navigateTo' expects a number!`;
    }
    if (tabIndex >= 0 && tabIndex < tabs.length) {
      setOpenedTab(tabIndex);
    }
  };

  useEffect(() => {
    if (onTabChange && typeof onTabChange === "function") {
      onTabChange(openedTab);
    }
    if (tabsRef && tabsRef.current) {
      tabsRef.current.parentNode.parentNode.scrollTop = 0;
    }
  }, [openedTab]);

  return (
    <div className="chronos-tabs-component" ref={tabsRef}>
      <div className="chronos-tab-labels">
        {tabs.map((tab, index) => {
          const isActive = index === openedTab;
          return (
            <TabLabel
              label={tab}
              key={index}
              active={isActive}
              set={() => setOpenedTab(index)}
            />
          );
        })}
      </div>
      <div className="chronos-tab-panes">
        {children.map((child, index) => {
          const isActive = index === openedTab;
          return (
            <TabPane
              component={child}
              active={isActive}
              className={"chronos-tab-pane"}
              // style={{ display: isHidden ? "none" : "block" }}
              key={index}
            />
          );
          // if (index === openedTab) {
          //   // console.log(child);
          //   return (
          //     <TabPane
          //       component={child}
          //       className="chronos-tab-pane"
          //       key={index}
          //     />
          //   );
          // } else {
          //   return null;
          // }
        })}
      </div>
    </div>
  );
});

function TabPane(props) {
  const { component, active } = props;

  return (
    <div
      className="chronos-tab-pane"
      style={{ display: active ? "block" : "none" }}
    >
      {component}
    </div>
  );
}

function TabLabel(props) {
  const { label, set, active } = props;
  // const handleClick = () => {};
  return (
    <div
      className={"chronos-tab-label" + (active ? " chronos-tab-active" : "")}
    >
      <button type="button" onClick={set}>
        {label}
      </button>
    </div>
  );
}
